/**
 * Human-readable labels for RBAC permission slugs (UI only).
 * Fallback: title-case slug segments.
 */
const PERMISSION_LABEL_OVERRIDES = {
  study_material_document: "Study Material Document",
  study_material: "Study Material",
  rbac_manage: "RBAC Manage",
  role_assign: "Role Assign",
  exam_mark_score: "Mark Exam Scores",
  exam_report_download: "Exam Report Download",
  chat_group: "Group Chat",
  chat_access: "Chat Access",
  user_import: "User Import",
  class_import: "Class Import",
  course_update: "Update Course",
  audit_read: "View Audit Logs",
  device_student_read: "View Student Device Login Requests",
  device_student_approve: "Approve Student Device Login",
  device_student_reject: "Reject Student Device Login",
  device_staff_read: "View Staff Device Login Requests",
  device_staff_approve: "Approve Staff Device Login",
  device_staff_reject: "Reject Staff Device Login",
  device_link: "Link Device",
};

export function formatPermissionSlugLabel(slug) {
  if (!slug || typeof slug !== "string") return "";
  const key = slug.trim().toLowerCase();
  if (PERMISSION_LABEL_OVERRIDES[key]) return PERMISSION_LABEL_OVERRIDES[key];
  return key
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function formatPermissionDisplay(permission) {
  if (!permission) return "";
  if (permission.name && String(permission.name).trim()) return permission.name;
  if (permission.label && String(permission.label).trim()) return permission.label;
  return formatPermissionSlugLabel(permission.slug || permission.formKey || "");
}
